import { Component } from 'react';

import { BLOB_URL } from '../config';
import { try_get_querystring_value } from '../querystring';

export class CustomerColors extends Component {
   constructor(props) {
      super(props);

      this.state = {
         customColors: null,
      };
   }

   async componentDidMount() {
      const [hasCustomerId, customerId] = try_get_querystring_value("customer");
      if (!hasCustomerId) {
         return;
      }

      const [loaded, colors] = await loadCustomerColors(customerId);
      if (loaded) {
         this.setState({ customColors: colors });
      }
   }

   render() {
      if (this.state.customColors) {
         let colors = "";

         if (this.state.customColors.light) {
            colors += ":root {\r\n";
            for (const name in this.state.customColors.light) {
               colors += `    --${name}: ${this.state.customColors.light[name]};\r\n`;
            }
            colors += "}\r\n";
         }

         if (this.state.customColors.dark) {
            colors += "@media (prefers-color-scheme: dark) {\r\n";
            colors += "    :root {\r\n";
            for (const name in this.state.customColors.dark) {
               colors += `        --${name}: ${this.state.customColors.dark[name]};\r\n`;
            }
            colors += "    }\r\n";
            colors += "}\r\n";
         }

         return (
            <style>{colors}</style>
         )
      }

      return (
         <>
         </>
      )
   }
}

async function loadCustomerColors(customerId) {
   try {
      const response = await fetch(`${BLOB_URL}/customer-branding/${customerId}/themes.json`, {
         cache: "no-store",
      });

      if (!response.ok) {
         return [false, null];
      }

      const colors = await response.json();

      return [true, colors];
   }
   catch {
      return [false, null];
   }
}